import ResourceImageList from "./resourceImage/PluginSetup.js";
function install(molten) {
  ResourceImageList.install(molten);
}
export default {
  install
};